import { connect } from "react-redux";
import { retryErroredActions, clearErrors } from "../../../../state/actions";
import DismissibleErrorBanner from "../../../presentational/common/DismissibleErrorBanner";
import getErrorMessage from "./getErrorMessage";
import getShowRetryButton from "../../common/DismissibleErrorBanner/getShowRetryButton";

const mapStateToProps = state => ({
  errorMessage: getErrorMessage(state),
  showRetryButton: getShowRetryButton(state)
});

const mapDispatchToProps = dispatch => ({
  onRetry: () => dispatch(retryErroredActions()),
  onDismiss: () => dispatch(clearErrors())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DismissibleErrorBanner);
